(function() {
    'use strict';

    angular
        .module('atheer.session')
        .controller('SessionInfoDialogController', SessionInfoDialogController);

    /* @ngInject */
    function SessionInfoDialogController($location, $mdDialog, $filter, sessionModel, workspaceCode, deviceDetector, ToastService, SessionExternalInvitee, sessionUsers) {
        var vm = this;

        vm.sessionModel = sessionModel;
        vm.sessionUsers = sessionUsers || [];
        vm.sessionUrl = "https://demo.atheer.my:3000/sessions/player" + vm.sessionModel.session_no;
        vm.code = workspaceCode;
        vm.isMobileBrowser = deviceDetector.isMobile();

        if ($location.host().endsWith("atheer.my")) {
            vm.sessionUrl = 'https://' + $location.host() + ":" + $location.port() + '/sessions/player/' + vm.sessionModel.session_no;
        } else {
            vm.sessionUrl = 'https://' + $location.host() + '/sessions/player/' + vm.sessionModel.session_no;
        };

        vm.getHostDisplayName = function() {
            var owner = (vm.sessionModel && vm.sessionModel.owner_info) || {};
            var ownerId = owner.id || (vm.sessionModel && vm.sessionModel.owner);
            // Prefer live Users-list name so Host line matches tiles/Users after remask / host transfer.
            var liveHost = findLiveSessionUser(ownerId);
            if (liveHost) {
                var liveName = (
                    (liveHost.maskedDisplayName && liveHost.useMaskedName === true
                        ? liveHost.maskedDisplayName
                        : ((liveHost.firstName || '') + ' ' + (liveHost.lastName || '')).trim())
                ).trim();
                if (liveName) {
                    return liveName;
                }
            }
            return SessionExternalInvitee.resolveApiVisibleDisplayName(
                owner,
                vm.sessionModel
            ) || (((owner.first_name || '') + ' ' + (owner.last_name || '')).trim());
        };

        function findLiveSessionUser(userId) {
            if (!vm.sessionUsers || userId == null || userId === '') {
                return null;
            }
            for (var i = 0; i < vm.sessionUsers.length; i++) {
                var u = vm.sessionUsers[i];
                if (!u) {
                    continue;
                }
                if (String(u.userId) === String(userId) || String(u.user_id) === String(userId)) {
                    return u;
                }
            }
            return null;
        }

        vm.onCopySuccess = function() {
            ToastService.displayToast($filter('translate')('atheer.session.info.copied'), 2000);
        };

        vm.close = function() {
            $mdDialog.cancel();
        };
    }
})();
